import React, { useEffect, useState } from 'react';
import './TestimonialTable.css';
import { DataGrid } from '@mui/x-data-grid';
import { DeleteOutline } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {  deleteTestimonial, getAllTestimonial } from '../../../redux/apiCalls';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { IMG_URL, addRowIndex, extractFileName } from '../../../config';
import CircleLoader from '../../../components/circleLoader/CircleLoader';

const TestimonialTable = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        getAllTestimonial(dispatch);
    }, [dispatch]);

    const isFetching = useSelector((state) => state.testimonial.isFetching);
    const testimonials = useSelector((state) => state.testimonial.testimonials);


     // Add index numbers to the testimonials array
     const testimonialsWithIndex = testimonials?.map((testimonial, index) => ({
        ...testimonial,
        index: index + 1, // Add 1 to the index to start from 1 instead of 0
    }));



    // const [testimonialsWithIndex, setTestimonialsWithIndex] = useState(null);

    // useEffect(() => {
    //     setTestimonialsWithIndex(addRowIndex(testimonials));
    // }, [testimonials]);
    // const admins = useSelector((state) => state.allUsers.users);


    // const handleDelete = (adminId) => {
    //     deleteAdmin(adminId, dispatch);
    //     setDeletePopup(false);
    // }
    const [deletePopup, setDeletePopup] = useState(false);
    const [deletingItem, setDeletingItem] = useState(null);
    const [testimoialImageName, setTestimoialImageName] = useState(null);
    
    const handleDelete = (testimonialId, filename) => {
        deleteTestimonial(testimonialId, filename, dispatch);
        setDeletePopup(false);
    }

    


    const handlePopup = (id, filename) => {
        setDeletePopup(true);
        setDeletingItem(id);
        setTestimoialImageName(filename);
    };

    const handlePopupCancel = () => {
        setDeletePopup(false);
    }

    const columns = [
        { field: 'index', headerName: '#', width: 50 },
        {
            field: 'testimonialImg',
            headerName: 'Image',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return <img src={params.value} className='courseTable-img' alt="user-img" />
            }
        },
        {
            field: 'parentName',
            headerName: 'Parent',
            width: 120,
            // editable: true,
            cellClassName : 'text-capitalize',
        },

        {
            field: 'childName',
            headerName: 'Child',
            width: 120,
            // editable: true,
            cellClassName : 'text-capitalize',
        },

        {
            field: 'category',
            headerName: 'Category',
            width: 120,
            // editable: true,
            cellClassName : 'text-capitalize',
        },

        
       
        {
            field: 'status',
            headerName: 'Status',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return params.row.status ? "Published" : "Draft";
            }
        },
        {
            field: 'Action',
            headerName: 'Action',
            sortable: false,
            width: 100,
            renderCell: (params) => {

                return (
                    <>
                        <Link to={'/edit-testimonial/' + params.id}>
                            <button className='btn btn-primary studentListEdit'>Edit</button>
                        </Link>
                        {/* <DeleteOutline className='studentListDelete text-danger' /> */}
                    </>
                )
            }
        },
        {
            field: 'delete',
            headerName: 'Delete',
            sortable: false,
            width: 100,
            renderCell: (params) => {
                const testimonialId = params.row._id;
                const testimonialImageURL = params.row.testimonialImg;
                const filename = extractFileName(testimonialImageURL)
                
                return (
                    <>
                        <DeleteOutline onClick={() => handlePopup(testimonialId, filename)} className='courseListDelete text-danger' />
                    </>
                )
            }
        },
    ];

    if (isFetching) {
        return (
            <div className='loader-wrapper'>
                <CircleLoader />
            </div>
        )
    }

    return (
        <div className='studentTableWrapper py-5'>
            <div className="row">
                <div className="col-12">
                    <div className="tableButtonWrapper d-flex justify-content-between mb-3">
                        <h2>Testimonials</h2>
                        <div className="buttonsWrapper d-flex gx-2">
                            {/* <Link to='/course-age-groups'>
                                <button className='custom-btn purple-bg'>Trainer Testimonial</button>
                            </Link> */}
                            <Link to='/new-testimonial'>
                                <button className='custom-btn purple-bg'>New Testimonial <AddCircleOutlineOutlinedIcon className='newStudentIcon' /></button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {
                deletePopup && (
                    <div className="deletePopupAlertWrapper">
                        <div className="deletePopupAlert">
                            <WarningAmberIcon style={{ color: "var(--orange)", fontSize: "40px" }} />
                            <h4>Warning</h4>
                            <div className="deleteAlertTextWrapper text-center">
                                <p>This testimonial will be deleted permanently.</p>
                                <p>Are you sure?</p>
                            </div>

                            <div className="deleteBtnsWrapper">
                                <button className='btn' onClick={handlePopupCancel} style={{ background: "var(--green)", color: "var(--white)" }}>Cancel</button>
                                <button className='btn' onClick={() => handleDelete(deletingItem, testimoialImageName)} style={{ background: "var(--red)", color: "var(--white)" }}>Delete</button>
                            </div>
                        </div>
                    </div>
                )
            }

            {
                testimonials && (
                    <DataGrid
                        rows={testimonialsWithIndex}
                        getRowId={(rows) => rows._id}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                        }}
                        pageSizeOptions={[10]}
                        checkboxSelection = {false}
                        disableRowSelectionOnClick
                    />
                )
            }


        </div>
    )
}

export default TestimonialTable
